import React from "react";
import {
  ClockCircleOutlined,
  EnvironmentOutlined,
  SolutionOutlined,
  HomeOutlined,
  TeamOutlined,
  ApartmentOutlined,
} from "@ant-design/icons";

const openingsLabel = (count) => `${count} opening${count > 1 ? "s" : ""}`;

/** Job facts as plain icon + text items (no tag pills, per the design rule). */
const JobMeta = ({ job, compact = false }) => {
  const items = [
    job.experience && { key: "experience", icon: <ClockCircleOutlined />, text: job.experience },
    job.location && { key: "location", icon: <EnvironmentOutlined />, text: job.location },
    job.employment_type && { key: "type", icon: <SolutionOutlined />, text: job.employment_type },
    job.work_mode && { key: "mode", icon: <HomeOutlined />, text: job.work_mode },
    !compact && job.department_id?.department_name && {
      key: "department",
      icon: <ApartmentOutlined />,
      text: job.department_id.department_name,
    },
    !compact && job.no_of_opening > 0 && { key: "openings", icon: <TeamOutlined />, text: openingsLabel(job.no_of_opening) },
  ].filter(Boolean);

  if (!items.length) return null;

  return (
    <div className={`career-job-meta${compact ? " career-job-meta-compact" : ""}`}>
      {items.map((item) => (
        <span className="career-meta-item" key={item.key}>
          {item.icon}
          {item.text}
        </span>
      ))}
    </div>
  );
};

export default JobMeta;
